module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"end":"Ende","exams":"Prüfungen","number":"Nummer","search":"Suche","start":"Start","subject":"Modul","title":"Bezeichnung","quota":"Quote"},"en":{"end":"End","exams":"Exams","number":"Number","search":"Search","start":"Start","subject":"Subject","title":"Title","quota":"Quota"}}')
  delete Component.options._Ctor
}
